import * as React from 'react';
import { Translate, TranslateProps } from '../i18n/Translate';

export interface Issue {
  type: string
  meta: object
}

export interface StructuredDataIssueTextProps extends TranslateProps {
  issue: Issue
}

const PARSE_ERROR_TYPES = new Set(['PARSE_ERROR', 'JSONLD_ERROR', 'RDFA_ERROR', 'MICRODATA_ERROR', 'JSON_PARSE_ERROR']);

export default function StructuredDataIssueText ({ issue, ...props }: StructuredDataIssueTextProps) {
  const content = PARSE_ERROR_TYPES.has(issue.type)
    ? 'structured_data_error_parse_error'
    : `structured_data_error_${issue.type.toLowerCase()}`;

  const withProp: { [key: string]: string } = { ...issue.meta };
  if (issue.type === 'INCOMPATIBLE_PROPERTIES') {
    withProp.joinedProperties = (issue.meta as any).properties.join('/');
  } else if (issue.type === 'REQUIRED_ONE_OF') {
    withProp.joinedProperties = (issue.meta as any).properties.join(', ');
  } else if (issue.type === 'INVALID_TYPE') {
    withProp.failedProperty = (issue.meta as any).property || (issue.meta as any).loc[1] || '';
  } else if (issue.type === 'REQUIRED_PROPERTY' && !withProp.type) {
    withProp.type = 'Thing';
  }

  return <Translate {...props} content={content} with={withProp} />;
}
